import React from 'react'
import { Link } from 'react-router-dom'
import logoImg from '../../assets/Augmentappz LLogo with text.png'

function IconMail() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
      <polyline points="22,6 12,13 2,6" />
    </svg>
  )
}

function IconInstagram() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
    </svg>
  )
}

function IconYouTube() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.97C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 0 0 1.46 6.42 29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58 2.78 2.78 0 0 0 1.95 1.97C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.95-1.97A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z" />
      <polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" />
    </svg>
  )
}

function IconLinkedIn() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
      <rect x="2" y="9" width="4" height="12" />
      <circle cx="4" cy="4" r="2" />
    </svg>
  )
}

function IconX() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.253 5.622 5.911-5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  )
}

export default function Footer() {
  const year = new Date().getFullYear()

  return (
    <footer className="site-footer">

      {/* ── Trust strip ── */}
      <div className="footer-trust-strip">
        <p className="footer-trust-text">
          AI-native execution&nbsp;&nbsp;&bull;&nbsp;&nbsp;Enterprise-grade systems&nbsp;&nbsp;&bull;&nbsp;&nbsp;Production-ready delivery
        </p>
      </div>

      {/* ── Main footer columns ── */}
      <div className="footer-main">
        <div className="container footer-main-inner">

          {/* Col 1 — Brand (36%) */}
          <div className="footer-brand-col">
            <Link to="/" className="footer-col-logo-link">
              <img src={logoImg} alt="AugmentAppz" className="footer-col-logo" />
            </Link>
            <p className="footer-col-tagline">
              Building the foundation<br />for AI-Native Organizations.
            </p>
            <p className="footer-col-desc">
              Product engineering, intelligent systems, and enterprise transformation designed for production-scale AI adoption.
            </p>
            <div className="footer-socials">
              <a href="https://www.instagram.com/augmentappzai/" target="_blank" rel="noopener noreferrer" className="footer-social-btn" aria-label="Instagram">
                <IconInstagram />
              </a>
              <a href="https://www.youtube.com/@AugmentAppz-ai" target="_blank" rel="noopener noreferrer" className="footer-social-btn" aria-label="YouTube">
                <IconYouTube />
              </a>
              <a href="https://www.linkedin.com/company/augmentappz" target="_blank" rel="noopener noreferrer" className="footer-social-btn" aria-label="LinkedIn">
                <IconLinkedIn />
              </a>
              <a href="https://x.com/augmentappz" target="_blank" rel="noopener noreferrer" className="footer-social-btn" aria-label="X (Twitter)">
                <IconX />
              </a>
            </div>
          </div>

          {/* Col 2 — Product (20%) */}
          <div className="footer-link-col footer-link-col--divided">
            <span className="footer-col-label">Product</span>
            <div className="footer-col-links">
              <a href="https://qraptor.ai/" target="_blank" rel="noopener noreferrer" className="footer-product-name">qRaptor</a>
              <p className="footer-product-desc">Enterprise orchestration platform for AI-driven execution.</p>
            </div>
          </div>

          {/* Col 3 — Company (18%) */}
          <div className="footer-link-col footer-link-col--divided">
            <span className="footer-col-label">Company</span>
            <div className="footer-col-links">
              <Link to="/about" className="footer-link">About Us</Link>
              <Link to="/contact" className="footer-link">Contact Us</Link>
            </div>
          </div>

          {/* Col 4 — Talk to Our Team (26%) */}
          <div className="footer-link-col footer-link-col--divided">
            <span className="footer-col-label">Talk to Our Team</span>
            <div className="footer-col-group">
              <a
                href="mailto:innovate@augmentappz.ai"
                className="footer-email-pill"
                aria-label="Email us at innovate@augmentappz.ai"
              >
                <IconMail />
                <span>innovate@augmentappz.ai</span>
              </a>
              <p className="footer-contact-micro">We typically respond within 24 hours.</p>
            </div>
          </div>

        </div>
      </div>

      {/* ── Bottom bar ── */}
      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <span className="footer-copy">&copy; {year} AugmentAppz. All rights reserved.</span>
          <nav className="footer-legal" aria-label="Legal links">
            <Link to="/privacy-policy" className="footer-legal-link">Privacy Policy</Link>
            <Link to="/terms" className="footer-legal-link">Terms &amp; Conditions</Link>
            <Link to="/cookie-policy" className="footer-legal-link">Cookie Policy</Link>
            <Link to="/disclaimer" className="footer-legal-link">Disclaimer</Link>
          </nav>
        </div>
      </div>

    </footer>
  )
}